import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/jobTrackingSyncStatus`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/jobTrackingSyncStatus`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/jobTrackingSyncStatus`;
